import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { clientActions } from "./actions";
import { ClientState } from "./types";

const initialState: ClientState = {
  clients: null,
};

export function ClientReducer(
  state = initialState,
  action: Action,
): ClientState {
  if (isType(action, clientActions.fetchClients.done)) {
    return {
      ...state,
      clients: action.payload.result.data.map((client) => ({
        id: client.id,
        name: client.name,
        parentId: client.parent_id,
        validPeriod: {
          from: new Date(client.valid_from),
          to: new Date(client.valid_to),
        },
      })),
    };
  }

  if (isType(action, clientActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
